import React from "react";
import { Col, Row } from "react-bootstrap";
import Select from "react-select";
import { getTodayDate } from "./attendanceReportDateUtils";
import "./attendanceFilters.css";

const applyButtonStyle = {
    backgroundColor: "var(--btn-primary-bg)",
    color: "var(--btn-primary-text)",
    border: "none",
    fontWeight: 600,
    padding: "8px 24px",
    borderRadius: "6px",
    fontSize: "14px",
};

const resetButtonStyle = {
    backgroundColor: "#FDE8E8",
    color: "#8B1A1A",
    border: "none",
    fontWeight: 600,
    padding: "8px 24px",
    borderRadius: "6px",
    fontSize: "14px",
};

const optionLabel = (value, label) => ({ value, label });

const AttendanceReportFilters = ({
    filterData,
    zoneOptions,
    wardOptions,
    shiftOptions,
    departmentOptions,
    onFilterChange,
    onApply,
    onReset,
}) => {
    const zoneOpts = zoneOptions.map((z) => optionLabel(z.zoneId ?? z.ZoneId, z.zoneName ?? z.ZoneName));
    const wardOpts = wardOptions.map((w) => optionLabel(w.circleId ?? w.wardId, w.circleName ?? w.wardName));
    const shiftOpts = shiftOptions
        .filter((s) => s.isActive)
        .map((s) => optionLabel(s.shiftId, s.shiftName));
    const departmentOpts = departmentOptions.map((d) => optionLabel(d.departmentId, d.departmentName));
    const statusOpts = [
        { value: "Present", label: "Present" },
        { value: "Absent", label: "Absent" },
        { value: "Late", label: "Late" },
    ];

    const getSelectedValue = (options, value) =>
        options.find((opt) => String(opt.value) === String(value)) || null;

    return (
        <div className="card mb-3 att-filters">
            <div className="card-body">
                <form onSubmit={onApply}>
                    <Row className="align-items-end g-2">
                        <Col xs={12} md={6} lg={3}>
                            <label className="form-label">Zone</label>
                            <Select
                                styles={{ control: (base) => ({ ...base, backgroundColor: "white" }) }}
                                name="ZoneId"
                                classNamePrefix="react-select"
                                options={zoneOpts}
                                value={getSelectedValue(zoneOpts, filterData.ZoneId)}
                                onChange={(selectedOption) =>
                                    onFilterChange("ZoneId", selectedOption ? selectedOption.value : "")
                                }
                                placeholder="Select Zone"
                                isClearable
                                isSearchable
                            />
                        </Col>

                        <Col xs={12} md={6} lg={3}>
                            <label className="form-label">
                                Ward
                                {!filterData.ZoneId && (
                                    <span className="text-muted ms-1" style={{ fontSize: "11px" }}>
                                        (select zone first)
                                    </span>
                                )}
                            </label>
                            <Select
                                styles={{ control: (base) => ({ ...base, backgroundColor: "white" }) }}
                                name="WardId"
                                classNamePrefix="react-select"
                                options={wardOpts}
                                value={getSelectedValue(wardOpts, filterData.WardId)}
                                onChange={(selectedOption) =>
                                    onFilterChange("WardId", selectedOption ? selectedOption.value : "")
                                }
                                placeholder="Select Ward"
                                isClearable
                                isSearchable
                                isDisabled={!filterData.ZoneId}
                            />
                        </Col>

                        <Col xs={12} md={6} lg={3}>
                            <label className="form-label">Employee Name / Code</label>
                            <input
                                type="text"
                                name="EmployeeSearch"
                                className="form-control bg-white"
                                placeholder="Search by name or code..."
                                value={filterData.EmployeeSearch}
                                onChange={(e) => onFilterChange(e.target.name, e.target.value)}
                            />
                        </Col>

                        <Col xs={12} md={6} lg={3}>
                            <label className="form-label">Status</label>
                            <Select
                                styles={{ control: (base) => ({ ...base, backgroundColor: "white" }) }}
                                name="Status"
                                classNamePrefix="react-select"
                                options={statusOpts}
                                value={statusOpts.find((opt) => opt.value === filterData.Status) || null}
                                onChange={(selectedOption) =>
                                    onFilterChange("Status", selectedOption ? selectedOption.value : "")
                                }
                                placeholder="Select Status"
                                isClearable
                                isSearchable
                            />
                        </Col>

                        <Col xs={12} md={6} lg={3}>
                            <label className="form-label">Shift</label>
                            <Select
                                styles={{ control: (base) => ({ ...base, backgroundColor: "white" }) }}
                                name="ShiftId"
                                classNamePrefix="react-select"
                                options={shiftOpts}
                                value={getSelectedValue(shiftOpts, filterData.ShiftId)}
                                onChange={(selectedOption) =>
                                    onFilterChange("ShiftId", selectedOption ? selectedOption.value : "")
                                }
                                placeholder="Select Shift"
                                isClearable
                                isSearchable
                            />
                        </Col>

                        <Col xs={12} md={6} lg={3}>
                            <label className="form-label">Department</label>
                            <Select
                                styles={{ control: (base) => ({ ...base, backgroundColor: "white" }) }}
                                name="DepartmentId"
                                classNamePrefix="react-select"
                                options={departmentOpts}
                                value={getSelectedValue(departmentOpts, filterData.DepartmentId)}
                                onChange={(selectedOption) =>
                                    onFilterChange("DepartmentId", selectedOption ? selectedOption.value : "")
                                }
                                placeholder="Select Department"
                                isClearable
                                isSearchable
                            />
                        </Col>

                        <Col xs={12} md={6} lg={3}>
                            <label className="form-label">From Date</label>
                            <input
                                type="date"
                                name="FromDate"
                                className="form-control bg-white"
                                value={filterData.FromDate}
                                max={
                                    filterData.ToDate && filterData.ToDate < getTodayDate()
                                        ? filterData.ToDate
                                        : getTodayDate()
                                }
                                onChange={(e) => onFilterChange(e.target.name, e.target.value)}
                            />
                        </Col>

                        <Col xs={12} md={6} lg={3}>
                            <label className="form-label">To Date</label>
                            <input
                                type="date"
                                name="ToDate"
                                className="form-control bg-white"
                                value={filterData.ToDate}
                                min={filterData.FromDate}
                                max={getTodayDate()}
                                onChange={(e) => onFilterChange(e.target.name, e.target.value)}
                            />
                        </Col>

                        <Col xs={12} className="att-filter-actions">
                            <button type="submit" style={applyButtonStyle}>
                                APPLY FILTERS
                            </button>
                            <button type="button" style={resetButtonStyle} onClick={onReset}>
                                RESET
                            </button>
                        </Col>
                    </Row>
                </form>
            </div>
        </div>
    );
};

export default AttendanceReportFilters;
